(function() {
  const CONFIG = {
    title: 'Quick Support',
    primaryColor: '#8BC34A',
    hoverColor: '#71a239',
    apiEndpoint: 'https://chat.befilament.com.au',
    greetingMessage: 'Hi! How can we assist you today?',
    errorMessage: 'Sorry, I didn\'t understand that.',
    networkErrorMessage: 'Sorry, something went wrong. Please try again.',
    quickStartQuestions: [
      'Which filament is right for me?',
      'How long does shipping take?'
    ],
    maxCharacters: 500,
    storagePrefix: 'blueEmberRAG_'
  };
  let DOM = {};
  function getOrCreateSessionId() {
    let sessionId = storage.get('sessionId');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
      storage.set('sessionId', sessionId);
    }
    return sessionId;
  }
  function checkRateLimit() {
    const now = Date.now();
    const oneHourAgo = now - (60 * 60 * 1000); 
    const MAX_MESSAGES_PER_HOUR = 30;
    let messageTimestamps = storage.get('messageTimestamps') || [];
    messageTimestamps = messageTimestamps.filter(timestamp => timestamp > oneHourAgo);
    if (messageTimestamps.length >= MAX_MESSAGES_PER_HOUR) {
      const oldestTimestamp = Math.min(...messageTimestamps);
      const timeUntilAvailable = oldestTimestamp + (60 * 60 * 1000) - now;
      const minutesRemaining = Math.ceil(timeUntilAvailable / (60 * 1000));
      return {
        allowed: false,
        minutesRemaining: minutesRemaining
      };
    }
    messageTimestamps.push(now);
    storage.set('messageTimestamps', messageTimestamps);
    return {
      allowed: true,
      remaining: MAX_MESSAGES_PER_HOUR - messageTimestamps.length
    };
  }
  const storage = {
    set: (key, value) => {
      try {
        localStorage.setItem(CONFIG.storagePrefix + key, JSON.stringify(value));
      } catch (e) {
        console.warn('LocalStorage error:', e);
      }
    },
    get: (key) => {
      try {
        const item = localStorage.getItem(CONFIG.storagePrefix + key);
        return item ? JSON.parse(item) : null;
      } catch (e) {
        console.warn('LocalStorage parse error:', e);
        return null;
      }
    },
    remove: (key) => {
      try {
        localStorage.removeItem(CONFIG.storagePrefix + key);
      } catch (e) {
        console.warn('LocalStorage remove error:', e);
      }
    },
    clearAll: (keys) => {
      keys.forEach(key => storage.remove(key));
    }
  };
  function injectChatbot() {
    const primaryColor = CONFIG.primaryColor;
    const hoverColor = CONFIG.hoverColor;
    const chatbotHTML = `
    <!-- Chat Popup Button -->
    <div id="chatToggle" class="chat-toggle">
      <div id="chatIcon">
        <svg class="svg-chat-closed" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
          <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"></path>
        </svg>
      </div>
    </div>
    <!-- Chat Window -->
    <div class="chat-popup" id="chatWidget">
      <div class="chat-header">
        <div class="chat-title">${CONFIG.title}</div>
        <button class="trash-btn" aria-label="Reset chat">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            <line x1="10" y1="11" x2="10" y2="17"></line>
            <line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
        </button>
        <button class="close-btn" aria-label="Close chat">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <button class="mobile-x-btn" aria-label="Close chat">×</button>
      </div>
      <!-- Confirmation Toast -->
      <div class="toast" id="confirmToast">
        <div class="toast-content">
          <p>Are you sure you want to clear the chat?</p>
          <div class="toast-buttons">
            <button class="toast-btn toast-cancel">Cancel</button>
            <button class="toast-btn toast-confirm">Confirm</button>
          </div>
        </div>
      </div>
      <div class="chat-content">
        <!-- Scrollable chat area -->
        <div class="messages" id="chatContainer"></div>
        <!-- Quick Replies -->
        <div class="quick-replies" id="quickReplies"></div>
        <!-- Input Area -->
        <div class="input-area">
          <input type="text" id="chatInput" placeholder="Type your message..." maxlength="500">
          <button id="sendButton">Send</button>
        </div>
      </div>
    </div>
    <style>
      #blue-ember-rag-chatbot-container * {
        box-sizing: border-box;
      }
      .input-area input[disabled],
      .input-area button[disabled] {
        background-color: #f0f0f0;
        color: #ccc;
        cursor: not-allowed;
      }
      .chat-header,
      .chat-title,
      .close-btn,
      .trash-btn,
      .mobile-x-btn {
        user-select: none;
      }
      .chat-toggle {
        position: fixed;
        bottom: 32px;
        right: 32px;
        background-color: ${primaryColor};
        color: white;
        font-size: 24px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 99;
        transition: all 0.2s ease-in-out;
      }
      .chat-toggle:hover {
        background-color: ${hoverColor};
      }
      .svg-chat-closed,
      .svg-chat-open {
        width: 32px;
        height: 32px;
        display: block;
        margin: auto;
      }
      .chat-popup {
        position: fixed;
        bottom: 112px;
        right: 32px;
        width: 360px;
        max-width: 95%;
        height: 640px;
        max-height: 70vh;
        background-color: #fff;
        border-radius: 16px;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        z-index: 100;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s, opacity 0.2s ease-in-out;
      }
      .chat-popup.show {
        visibility: visible;
        opacity: 1;
      }
      .chat-header {
        background-color: #f5f5f5;
        padding: 12px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        border-bottom: 1px solid #e0e0e0;
      }
      .chat-title {
        font-size: 16px;
        font-weight: 600;
        flex: 1;
      }
      .chat-header button {
        background: none;
        border: none;
        font-size: 18px;
        color: #888;
        cursor: pointer;
        transition: color 0.2s ease;
      }
      .close-btn,
      .trash-btn,
      .mobile-x-btn {
        margin-left: 8px;
      }
      .close-btn:hover,
      .trash-btn:hover,
      .mobile-x-btn:hover {
        color: #555;
      }
      .mobile-x-btn {
        display: none;
        font-size: 24px;
        font-weight: bold;
      }
      .toast {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        padding: 24px;
        z-index: 1000;
        display: none;
        min-width: 300px;
        max-width: 90%;
      }
      .toast.show {
        display: block;
      }
      .toast-content p {
        margin: 0 0 20px 0;
        font-size: 16px;
        color: #333;
        text-align: center;
      }
      .toast-buttons {
        display: flex;
        gap: 12px;
        justify-content: center;
      }
      .toast-btn {
        flex: 1;
        padding: 10px 20px;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
        transition: background-color 0.2s;
      }
      .toast-cancel {
        background: #f5f5f5;
        color: #666;
      }
      .toast-cancel:hover {
        background: #e0e0e0;
      }
      .toast-confirm {
        background: ${primaryColor};
        color: white;
      }
      .toast-confirm:hover {
        background: ${hoverColor};
      }
      .chat-content {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
      }
      .messages {
        flex-grow: 1;
        padding: 12px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 8px;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
      }
      .message-wrapper {
        display: flex;
        flex-direction: row;
        width: 100%;
      }
      .message {
        max-width: 80%;
        padding: 10px 14px;
        border-radius: 16px;
        font-size: 14px;
        word-break: break-word;
        line-height: 1.4;
        white-space: pre-wrap;
      }
      .message.bot {
        background-color: #f1f1f1;
        align-self: flex-start;
      }
      .message.user {
        background-color: ${primaryColor};
        color: white;
        align-self: flex-end;
        margin-left: auto;
      }
      .message a {
        color: inherit;
        text-decoration: underline;
      }
      .typing-indicator {
        max-width: 80%;
        padding: 14px 18px;
        border-radius: 16px;
        background-color: #f1f1f1;
        align-self: flex-start;
        display: flex;
        align-items: center;
        gap: 4px;
        height: auto;
        line-height: 1.4;
      }
      .typing-indicator span {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #888;
        animation: typing 1.4s infinite;
      }
      .typing-indicator span:nth-child(1) {
        animation-delay: 0s;
      }
      .typing-indicator span:nth-child(2) {
        animation-delay: 0.2s;
      }
      .typing-indicator span:nth-child(3) {
        animation-delay: 0.4s;
      }
      @keyframes typing {
        0%, 60%, 100% {
          transform: translateY(0);
          opacity: 0.7;
        }
        30% {
          transform: translateY(-10px);
          opacity: 1;
        }
      }
      .quick-replies {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 10px 12px;
        border-top: 1px solid #eee;
        background-color: #fafafa;
      }
      .quick-replies.hidden {
        display: none;
      }
      .quick-reply {
        background-color: ${primaryColor};
        color: white;
        border: none;
        border-radius: 20px;
        padding: 8px 14px;
        font-size: 14px;
        cursor: pointer;
        transition: background-color 0.3s;
      }
      .quick-reply:hover {
        background-color: ${hoverColor};
      }
      .input-area {
        display: flex;
        gap: 8px;
        padding: 12px;
        border-top: 1px solid #e0e0e0;
        background-color: #fff;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
      }
      .input-area input {
        flex-grow: 1;
        padding: 10px 14px;
        border-radius: 20px;
        border: 1px solid #ccc;
        font-size: 14px;
        outline: none;
        transition: border-color 0.2s ease;
      }
      .input-area input:focus {
        border-color: ${primaryColor};
      }
      .input-area button {
        background-color: ${primaryColor};
        color: white;
        border: none;
        border-radius: 20px;
        padding: 10px 16px;
        cursor: pointer;
        font-size: 14px;
        transition: background-color 0.3s;
      }
      .input-area button:disabled {
        background-color: #e0e0e0;
        cursor: not-allowed;
      }
      .input-area button:enabled:hover {
        background-color: ${hoverColor};
      }
      @media (max-width: 767px) {
        .chat-popup {
          width: 100%;
          height: 100%;
          max-width: none;
          max-height: none;
          border-radius: 0;
          bottom: 0;
          right: 0;
          position: fixed;
        }
        body.chat-open {
          overflow: hidden;
        }
        .close-btn {
          display: none;
        }
        .mobile-x-btn {
          display: block;
        }
        .messages {
          padding: 16px;
          gap: 12px;
          -webkit-overflow-scrolling: touch;
        }
        .chat-header {
          padding: 16px;
          font-size: 18px;
        }
        .input-area {
          padding: 16px;
        }
        input:focus {
          font-size: 16px;
        }
      }
      @media screen and (max-height: 800px) {
        .chat-popup {
          height: 100dvh;
        }
      }
      @media (max-height: 600px) {
        .chat-popup {
          height: 100dvh;
        }
      }
    </style>
    `;
    const container = document.createElement('div');
    container.id = 'blue-ember-rag-chatbot-container';
    container.innerHTML = chatbotHTML;
    document.body.appendChild(container);
  }
  function setupEventListeners() {
    DOM = {
      chatWidget: document.getElementById('chatWidget'),
      chatToggle: document.getElementById('chatToggle'),
      chatContainer: document.getElementById('chatContainer'),
      chatInput: document.getElementById('chatInput'),
      sendButton: document.getElementById('sendButton'),
      quickReplies: document.getElementById('quickReplies'),
      chatIcon: document.getElementById('chatIcon'),
      closeBtn: document.querySelector('.close-btn'),
      trashBtn: document.querySelector('.trash-btn'),
      mobileXBtn: document.querySelector('.mobile-x-btn'),
      confirmToast: document.getElementById('confirmToast'),
      toastCancel: document.querySelector('.toast-cancel'),
      toastConfirm: document.querySelector('.toast-confirm')
    };
    DOM.chatToggle.addEventListener('click', toggleChat);
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      DOM.chatToggle.addEventListener('touchend', function(e) {
        e.preventDefault();
        toggleChat();
        return false;
      }, { passive: false });
    }
    DOM.closeBtn.addEventListener('click', toggleChat);
    DOM.mobileXBtn.addEventListener('click', toggleChat);
    DOM.trashBtn.addEventListener('click', showResetConfirmation);
    DOM.toastCancel.addEventListener('click', hideResetConfirmation);
    DOM.toastConfirm.addEventListener('click', confirmResetChat);
    DOM.sendButton.addEventListener('click', sendMessage);
    DOM.chatInput.addEventListener('keydown', handleKeyDown);
    DOM.chatContainer.addEventListener('scroll', saveScrollPosition);
    setupMobileTouchHandlers();
  }
  function setupMobileTouchHandlers() {
    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            if (DOM.chatWidget.classList.contains('show')) {
              storage.set('scrollY', window.scrollY);
            } else {
              setTimeout(() => {
                window.scrollTo(0, storage.get('scrollY') || 0);
              }, 100);
            }
          }
        });
      });
      observer.observe(DOM.chatWidget, { attributes: true });
    }
  }
  function updateChatIcon(isOpen) {
    const iconHTML = isOpen
      ? `<svg class="svg-chat-open" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>`
      : `<svg class="svg-chat-closed" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"></path></svg>`;
    DOM.chatIcon.innerHTML = iconHTML;
  }
  function toggleChat() {
    const chatWidget = document.getElementById('chatWidget');
    const isOpen = !chatWidget.classList.contains('show');
    if (isOpen) {
      chatWidget.classList.add('show');
      chatWidget.style.display = 'flex';
      document.body.classList.add('chat-open');
    } else {
      chatWidget.classList.remove('show');
      document.body.classList.remove('chat-open');
    }
    storage.set('chatOpen', isOpen);
    updateChatIcon(isOpen);
    if (isOpen && DOM.chatInput) {
      setTimeout(() => DOM.chatInput.focus(), 300);
    }
  }
  function formatMessageText(text) {
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
    text = text.replace(/\n/g, '<br>');
    const processedLinks = [];
    text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function(match, linkText, url) {
      if (url.includes('befilament.com.au')) {
        url = url + (url.includes('?') ? '&' : '?') + 'utm_source=chat';
      }
      const linkHtml = `<a href="${url}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
      const placeholder = `__LINK_${processedLinks.length}__`;
      processedLinks.push(linkHtml);
      return placeholder;
    });
    text = text.replace(/(https?:\/\/[^\s<)\]]+)/g, function(match, url) {
      const trailingPunct = url.match(/[.,!?;:]+$/);
      const trailing = trailingPunct ? trailingPunct[0] : '';
      url = url.replace(/[.,!?;:]+$/, '');
      let finalUrl = url;
      if (url.includes('befilament.com.au')) {
        finalUrl = url + (url.includes('?') ? '&' : '?') + 'utm_source=chat';
      }
      return `<a href="${finalUrl}" target="_blank" rel="noopener noreferrer">${url}</a>${trailing}`;
    });
    text = text.replace(emailRegex, '<a href="mailto:$1">$1</a>');
    const phoneRegex = /(\+?\d{1,3}[\s.\-]?)?\(?\d{2,4}\)?[\s.\-]?\d{3,4}[\s.\-]?\d{3,4}\b/g;
    text = text.replace(phoneRegex, function(match) {
      const cleanNumber = match.replace(/[\s.\-()]/g, '');
      if (cleanNumber.length >= 8) {
        return `<a href="tel:${cleanNumber}">${match}</a>`;
      }
      return match;
    });
    processedLinks.forEach((linkHtml, index) => {
      text = text.replace(`__LINK_${index}__`, linkHtml);
    });
    return text;
  }
  function appendMessage(type, text, sources = null, skipSave = false, isHtml = false) {
    const msgWrapper = document.createElement('div');
    msgWrapper.className = `message-wrapper ${type}`;
    const msg = document.createElement('div');
    msg.className = `message ${type}`;
    msg.innerHTML = isHtml ? text : formatMessageText(text);
    msgWrapper.appendChild(msg);
    DOM.chatContainer.appendChild(msgWrapper);
    if (!skipSave) {
      scrollToBottom();
      saveChatHistory();
    }
  }
  function saveChatHistory() {
    const allMessages = Array.from(DOM.chatContainer.querySelectorAll('.message')).map(msg => ({
      type: msg.classList.contains('user') ? 'user' : 'bot',
      html: msg.innerHTML  
    }));
    storage.set('chatHistory', allMessages);
  }
  function saveScrollPosition() {
    if (DOM.chatContainer) {
      storage.set('chatScrollPosition', DOM.chatContainer.scrollTop);
    }
  }
  function restoreChatHistory() {
    const history = storage.get('chatHistory');
    if (Array.isArray(history)) {
      const originalScrollBehavior = DOM.chatContainer.style.scrollBehavior;
      DOM.chatContainer.style.scrollBehavior = 'auto';
      history.forEach(msg => {
        const content = msg.html || msg.text;
        const isHtml = !!msg.html;
        appendMessage(msg.type, content, null, true, isHtml);
      });
      const savedScrollPosition = storage.get('chatScrollPosition');
      if (savedScrollPosition !== null) {
        DOM.chatContainer.scrollTop = savedScrollPosition;
      } else {
        DOM.chatContainer.scrollTop = DOM.chatContainer.scrollHeight;
      }
      DOM.chatContainer.style.scrollBehavior = originalScrollBehavior;
    }
  }
  function generateQuickReplyButtons(replies = []) {
    DOM.quickReplies.innerHTML = '';
    replies.forEach(reply => {
      const btn = document.createElement('button');
      btn.className = 'quick-reply';
      btn.innerText = reply;
      btn.addEventListener('click', () => sendQuickReply(reply));
      DOM.quickReplies.appendChild(btn);
    });
  }
  function restoreState() {
    restoreChatOpenState();
    restoreChatHistory();
    const history = storage.get('chatHistory');
    if (!Array.isArray(history) || history.length === 0) {
      appendMessage('bot', CONFIG.greetingMessage, null, true);
      generateQuickReplyButtons(CONFIG.quickStartQuestions);
    } else {
      const quickRepliesHidden = storage.get('quickRepliesHidden');
      if (quickRepliesHidden) {
        DOM.quickReplies.classList.add('hidden');
      } else {
        generateQuickReplyButtons(CONFIG.quickStartQuestions);
      }
    }
  }
  function restoreChatOpenState() {
    const isOpen = storage.get('chatOpen');
    const chatWidget = document.getElementById('chatWidget');
    if (isOpen) {
      chatWidget.classList.add('show');
      chatWidget.style.display = 'flex';
    } else {
      chatWidget.classList.remove('show');
    }
    updateChatIcon(isOpen);
  }
  function showResetConfirmation() {
    DOM.confirmToast.classList.add('show');
  }
  function hideResetConfirmation() {
    DOM.confirmToast.classList.remove('show');
  }
  function confirmResetChat() {
    hideResetConfirmation();
    storage.clearAll(['chatHistory', 'chatOpen', 'quickRepliesHidden', 'chatScrollPosition']);
    DOM.chatContainer.innerHTML = '';
    appendMessage('bot', CONFIG.greetingMessage, null, true);
    generateQuickReplyButtons(CONFIG.quickStartQuestions);
    DOM.quickReplies.classList.remove('hidden');
    toggleChat();
  }
  function sendQuickReply(reply) {
    DOM.chatInput.value = reply;
    sendMessage();
  }
  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      sendMessage();
    }
  }
  function scrollToBottom() {
    setTimeout(() => {
      DOM.chatContainer.scrollTop = DOM.chatContainer.scrollHeight;
    }, 50);
  }
  function showTypingIndicator() {
    const typingDiv = document.createElement('div');
    typingDiv.className = 'typing-indicator';
    typingDiv.id = 'typing-indicator';
    typingDiv.innerHTML = '<span></span><span></span><span></span>';
    DOM.chatContainer.appendChild(typingDiv);
    scrollToBottom();
  }
  function removeTypingIndicator() {
    const typingIndicator = document.getElementById('typing-indicator');
    if (typingIndicator) {
      typingIndicator.remove();
    }
  }
  async function sendMessage() {
    const text = DOM.chatInput.value.trim();
    if (!text) return;
    if (text.length > CONFIG.maxCharacters) {
      appendMessage('bot', `Your message is too long (${text.length} characters). Please keep it under ${CONFIG.maxCharacters} characters.`);
      return;
    }
    const rateLimitCheck = checkRateLimit();
    if (!rateLimitCheck.allowed) {
      appendMessage('bot', `You've reached the message limit. Please wait ${rateLimitCheck.minutesRemaining} minute${rateLimitCheck.minutesRemaining === 1 ? '' : 's'} and try again, or contact us at contact@befilament.com.au`);
      return;
    }
    if (!DOM.quickReplies.classList.contains('hidden')) {
      DOM.quickReplies.classList.add('hidden');
      storage.set('quickRepliesHidden', true);
    }
    DOM.chatInput.disabled = true;
    DOM.sendButton.disabled = true;
    appendMessage('user', text);
    DOM.chatInput.value = '';
    const history = buildConversationHistory();
    showTypingIndicator();
    try {
      const sessionId = getOrCreateSessionId();
      const conversationPosition = Math.floor((DOM.chatContainer.querySelectorAll('.message.user').length) / 2) + 1;
      const res = await fetch(CONFIG.apiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          question: text,
          history: history,
          sessionId: sessionId,
          conversationPosition: conversationPosition
        })
      });
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const data = await res.json();
      removeTypingIndicator();
      if (data.rateLimited) {
        appendMessage('bot', data.error || 'Our chat is experiencing high demand. Please try again later. For immediate assistance, contact us at contact@befilament.com.au');
      } else if (data.error) {
        appendMessage('bot', `${CONFIG.errorMessage} ${data.error}`);
      } else if (data.answer) {
        appendMessage('bot', data.answer);
      } else {
        appendMessage('bot', CONFIG.errorMessage);
      }
    } catch (err) {
      console.error('Error sending message:', err);
      removeTypingIndicator();
      appendMessage('bot', CONFIG.networkErrorMessage);
    } finally {
      DOM.chatInput.disabled = false;
      DOM.sendButton.disabled = false;
      DOM.chatInput.focus();
    }
  }
  function buildConversationHistory() {
    const messages = Array.from(DOM.chatContainer.querySelectorAll('.message'));
    const history = [];
    const relevantMessages = messages.slice(-7, -1); 
    for (const msg of relevantMessages) {
      const role = msg.classList.contains('user') ? 'user' : 'assistant';
      const content = msg.innerText;
      if (content !== CONFIG.greetingMessage) {
        history.push({ role, content });
      }
    }
    return history;
  }
  async function checkGeolocation() {
    try {
      const response = await fetch(`${CONFIG.apiEndpoint}/geo`);
      const data = await response.json();
      return data.country === 'AU';
    } catch (error) {
      console.warn('Geolocation check failed, allowing chat:', error);
      return true; 
    }
  }
  function showNonAUMessage() {
    const chatToggle = document.getElementById('chatToggle');
    if (chatToggle) {
      chatToggle.style.display = 'none';
    }
  }
  async function initChatbot() {
    const isAustralian = await checkGeolocation();
    if (!isAustralian) {
      showNonAUMessage();
      return; 
    }
    setupEventListeners();
    restoreState();
  }
  injectChatbot();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatbot);
  } else {
    initChatbot();
  }
})();
